import * as React from 'react'

import { Notification, NotificationPosition, Paragraph, useNotification } from '../../../../components'
import { NotificationTheme } from '../../../../components/notification/notification'
import { useRatingMutation } from './useRatingMutation'

export const useRating = (initialLiked: boolean | null, showFeedbackDialog?: () => void) => {
  const [liked, setLiked] = React.useState<boolean | null>(initialLiked)
  const { rateMutation } = useRatingMutation()
  const notification = useNotification()

  const doRating = React.useCallback(
    (stockWhyMovingHistoryId: number, likedNewState: boolean, text?: string, skipFeedbackDialog?: boolean) => {
      const likeBeforeChange = liked
      setLiked(likedNewState)

      rateMutation.mutate(
        {
          stockWhyMovingHistoryId,
          liked: likedNewState,
          text,
        },
        {
          onError: (error) => {
            Sentry.captureException(error)
            setLiked(likeBeforeChange)

            notification.show(
              <Notification closeText="Got it" timeoutInMs={6000} theme={NotificationTheme.failure}>
                <Paragraph className="flex max-w-40 items-center">Failed to save changes. Please try again.</Paragraph>
              </Notification>,
              { position: NotificationPosition.TopRight }
            )
          },
        }
      )

      if (!likedNewState && !skipFeedbackDialog) {
        showFeedbackDialog?.()
      }
    },
    [showFeedbackDialog, rateMutation, liked, notification]
  )

  return { liked, setLiked, doRating }
}
